<div class="card">
  <app-card-title key="project.steps.rfq.invitationResult" />
  @if (!isStepPrerequisiteCompleted()) {
    <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
  } @else {
    <p-tabs
      appTabsUnsavedReveal
      [value]="activeTabIndex()"
      (valueChange)="onTabChange($event!)"
      scrollable
    >
      <p-tablist>
        <p-tab [value]="0" [appTabStatus]="priceListTabStatus()">
          {{ 'project.steps.rfq.invitationResult.tab.priceList' | transloco }}
        </p-tab>
        <p-tab [value]="1" [appTabStatus]="uploadedDocumentsTabStatus()">
          {{ 'project.steps.rfq.invitationResult.tab.uploadDocuments' | transloco }}
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-card>
          <p-tabpanel [value]="0">
            <app-step-8-4-1-rfq-provider-results-price-list />
          </p-tabpanel>

          <p-tabpanel [value]="1">
            <app-step-8-4-2-provider-results-documents />
          </p-tabpanel>
        </p-card>
      </p-tabpanels>
    </p-tabs>
  }
</div>
